// @flow
import React from 'react';
import { PILLS } from './data';
import { /* PillContainer, */ PillsContainer } from './partials';
import { PillCard } from './components';

const Pills = () => (
  <PillsContainer>
    {PILLS.map(item => (
      <PillCard key={item.id} pill={item} />
    ))}

    {PILLS.length % 3 !== 0 && <PillCard />}
  </PillsContainer>
);

export default Pills;
